module.exports = __webpack_public_path__ + "static/media/Artwork4.67949d34.png";